import { render, staticRenderFns } from "./SearchResultMedical.vue?vue&type=template&id=3c0c90fa&scoped=true&"
import script from "./SearchResultMedical.vue?vue&type=script&lang=js&"
export * from "./SearchResultMedical.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultMedical.vue?vue&type=style&index=0&id=3c0c90fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c90fa",
  null
  
)

export default component.exports